import { weights } from '../context/CerebroThemeProvider';
import { styled } from '@mui/material';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';

function Button<D extends React.ElementType<any> = 'button'>(props: CerebroPrimaryButtonProps<D>) {
	return <LoadingButton {...props} />;
}

type CerebroPrimaryButtonProps<D extends React.ElementType<any> = 'button'> = LoadingButtonProps<D> & {
	wide?: boolean;
};

export const CerebroPrimaryButton = styled(Button, {
	shouldForwardProp: prop => prop !== 'wide',
})(({ wide = false, theme }) => ({
	backgroundColor: theme.palette.primary.main,
	borderRadius: 100,
	border: `1px solid ${theme.palette.primary.main}`,
	color: theme.palette.gray.dark,
	fontWeight: weights.semibold,
	fontSize: 16,
	lineHeight: '18px',
	textTransform: 'none',

	boxShadow: theme.shadows[3],

	padding: wide ? theme.spacing(1.5, 6) : theme.spacing(1.5, 3),

	'&:hover': {
		background: theme.palette.primary.light,
		borderColor: theme.palette.gray.dark,
	},
}));
